import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-6 px-4 text-center" data-testid="not-found-page">
      <p className="font-display text-7xl font-black text-navy">404</p>
      <p className="max-w-md text-slate-600">
        This page has evolved into something else. Let's take you back to solid ground.
      </p>
      <Link to="/" className="btn-primary" data-testid="not-found-home-link">
        Back to Home
      </Link>
    </div>
  );
}
